var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "-11 0 496 496",
    width: "496pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "973c1053-bd07-4fc7-911c-3a02ee7c847f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00efd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00acea"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3da96420-a9be-4467-a9bb-410b0452bd45",
    gradientUnits: "userSpaceOnUse",
    x1: 201.1759,
    x2: 212.1759,
    xlinkHref: "#973c1053-bd07-4fc7-911c-3a02ee7c847f",
    y1: 182.4068,
    y2: 420.4068
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "01f4bcad-d0f2-4b70-8896-8efa5259fa44",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9915,
    x2: 168.9915,
    xlinkHref: "#973c1053-bd07-4fc7-911c-3a02ee7c847f",
    y1: 184.4028,
    y2: 422.4028
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b86ad312-8a8c-4fbf-84d9-41513b622c22",
    gradientUnits: "userSpaceOnUse",
    x1: 204.78,
    x2: 215.78,
    xlinkHref: "#973c1053-bd07-4fc7-911c-3a02ee7c847f",
    y1: 182.2403,
    y2: 420.2403
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "13009e2e-40a6-45f0-b534-dad11d31d436",
    gradientUnits: "userSpaceOnUse",
    x1: 202.9814,
    x2: 213.9814,
    xlinkHref: "#973c1053-bd07-4fc7-911c-3a02ee7c847f",
    y1: 182.3234,
    y2: 420.3234
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f5764b15-de71-4bcf-a130-18f7adb88715",
    gradientUnits: "userSpaceOnUse",
    x1: 230.4895,
    x2: 241.4895,
    xlinkHref: "#973c1053-bd07-4fc7-911c-3a02ee7c847f",
    y1: 181.052,
    y2: 419.052
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m325.398438 385.101562h-228.898438c-4.398438 0-8 3.597657-8 8 0 4.398438 3.601562 8 8 8h228.898438c4.402343 0 8-3.601562 8-8 0-4.402343-3.597657-8-8-8zm0 0",
    fill: "url(#3da96420-a9be-4467-a9bb-410b0452bd45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 284h131.5c4.398438 0 8-3.601562 8-8s-3.601562-8-8-8h-131.5c-4.398438 0-8 3.601562-8 8s3.5 8 8 8zm0 0",
    fill: "url(#01f4bcad-d0f2-4b70-8896-8efa5259fa44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m88.5 315c0 4.398438 3.601562 8 8 8h228.898438c4.402343 0 8-3.601562 8-8s-3.597657-8-8-8h-228.898438c-4.5 0-8 3.601562-8 8zm0 0",
    fill: "url(#b86ad312-8a8c-4fbf-84d9-41513b622c22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m325.398438 346h-228.898438c-4.398438 0-8 3.601562-8 8s3.601562 8 8 8h228.898438c4.402343 0 8-3.601562 8-8s-3.597657-8-8-8zm0 0",
    fill: "url(#13009e2e-40a6-45f0-b534-dad11d31d436)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m472.398438 179.5c-.597657-.898438-1.398438-1.800781-2.398438-2.398438l-40.5-26.601562c-1.300781-.898438-2.800781-1.398438-4.398438-1.5h-22.101562v-43.601562c-.199219-2.699219-1.5-5.199219-3.601562-6.898438l-92.199219-94c-.5-.699219-1.097657-1.398438-1.898438-1.898438l-.300781-.203124c-1.5-1.5-3.601562-2.398438-5.699219-2.398438h-215c-22.699219 0-41.800781 15.800781-45.5 36.601562-21.902343 3.398438-38.800781 21.5-38.800781 43.398438v372c0 24.300781 21 44 46.398438 44h272.5c22.800781 0 41.703124-15.800781 45.402343-36.601562 21.898438-3.398438 38.699219-21.5 38.699219-43.398438v-198h22.101562c1.5 0 3.097657-.398438 4.398438-1.199219l40.5-26.300781c3.699219-2.398438 4.800781-7.300781 2.398438-11zm-163.398438-150.699219 66.300781 68.199219h-55.601562c-5.800781.101562-10.597657-4.398438-10.699219-10.199219zm9.898438 451.199219h-272.5c-16.597657 0-30.398438-12.5-30.398438-28v-372c0-12.800781 10-23.699219 22-27v363c0 24.300781 21 44 46.398438 44h263.402343c-3.699219 12-15.300781 20-28.902343 20zm68.101562-64c0 15.398438-13.5 28-30.101562 28h-272.5c-16.597657 0-30.398438-12.5-30.398438-28v-370.800781c0-.398438.300781-.800781.300781-1.199219 0-.300781 0-.699219 0-1 .597657-15 13.898438-27 30.097657-27h208.601562v70.800781c.101562 14.597657 12.101562 26.398438 26.699219 26.199219h67.300781v36h-258.601562c-4.597657.199219-8.199219 3.898438-8.398438 8.5v1l-23.800781-.5h-.097657c-4.5.101562-8 3.800781-8 8.199219l.296876 34.800781c0 4.398438 3.601562 7.898438 8 7.898438h23.601562v1.203124c0 4.398438 4 7.796876 8.398438 7.796876h16.902343l-.101562 12c-.097657 4.601562 1.601562 9 4.800781 12.300781 2.699219 2.902343 6.398438 4.601562 10.398438 4.699219h97.101562c4.398438 0 8-3.597657 8-8 0-4.398438-3.601562-8-8-8h-96.199219c0-1 0-.5 0-.597657l.097657-12.402343h225.601562zm-267-241.5v18.5h-15.699219l-.300781-18.699219zm297 27.5h-281v-37h281zm16-6.601562v-23.199219l17.800781 11.601562zm0 0",
    fill: "url(#f5764b15-de71-4bcf-a130-18f7adb88715)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyDark);
export default __webpack_public_path__ + "static/media/SurveyDark.d11f211a.svg";
export { ForwardRef as ReactComponent };